import axios from 'axios';
import { setupCache, buildWebStorage } from 'axios-cache-interceptor';

const globalCacheFlag = 'axios-cache:';

const instance = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

export const axiosInstance = setupCache(instance, {
  cacheTakeover: false,
  ttl: 1000 * 60 * 10, // 10 minutes
  storage: buildWebStorage(localStorage, globalCacheFlag)
});

export const invalidateCache = async (key) => {
  localStorage.removeItem(`${globalCacheFlag}${key}`);
};
